import { render } from "./Remove.vue?vue&type=template&id=751d259b"
const script = {}

import "./Remove.vue?vue&type=style&index=0&id=751d259b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__